<template>
  <input v-model="value" @change="toggle" :id="'select-' + list + '-all'" class="custom-checkbox" type="checkbox"/>
  <label :for="'select-' + list + '-all'" class="checkbox-inline font-bold">{{ label }}<slot></slot></label>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useCheckboxListStore } from "../stores/checkboxList"

export default {
  emits: ['itemsUpdated', 'allUpdated'],

  props: {
    list: {
      type: String,
      default: 'default'
    },
    ids: {
      type: Array,
      default: () => {return []}
    },
    label: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      value: false,
    }
  },

  computed: {
    ...mapState(useCheckboxListStore, ['checkedIds', 'allSelected']),

    checkedIdsValue() {
      return this.checkedIds(this.list);
    },

    allSelectedValue() {
      return this.allSelected(this.list);
    },
  },

  methods: {
    ...mapActions(useCheckboxListStore, ['initList', 'applyAll']),

    reloadList() {
      this.initList(this.list, this.ids);
      // Emit the "itemsUpdated" event when the list is initialized or reinitialized.
      this.$emit('itemsUpdated', this.checkedIdsValue);
    },

    toggle() {
      // Handle "all" value update.
      this.applyAll(this.value, this.list);
    }
  },

  created() {
    // Initialize the list on component creation.
    this.reloadList();
  },

  watch: {
    value: {
      handler(value) {
        // Watch the value changed from any source
        // (e.g., when checkbox checked or when all checkboxes checked one by one)
        // to emit the "allUpdated" event.
        this.$emit('allUpdated', value);
      }
    },
    ids: {
      deep: true,
      handler (value, oldValue) {
        // Watch the "ids" property for changes. This will reload the list, e.g., if some items are removed.
        if (value.length !== oldValue.length) this.reloadList();
      }
    },
    checkedIdsValue: {
      deep: true,
      handler (value) {
        // Watch the checked items changed to emit the "itemsUpdated" event.
        this.$emit('itemsUpdated', value);
      }
    },
    allSelectedValue: {
      handler (value) {
        // Watch the value changed from outside the component. E.g., when all checkboxes checked one by one.
        this.value = value;
      }
    }
  }
}
</script>
